export const useTabsOrder = (list) => list.sort((a, b) => {
    if (a.position && b.position) {
        return a.position - b.position;
    }
    return 0;
});
//# sourceMappingURL=useTabsOrder.js.map